import React from 'react';
import '../template-file-css/document-file-template.css';


export const NWBH_InitialTreatmentPlan = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='NWBH_InitialTreatmentPlan' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><h3>Initial Treatment Plan</h3></p>

                <p className='w-750'>
                    DSM IV Diagnostic Impression : <input type='text' id='txtDiagnostic' name='txtDiagnostic' className='add-only w-350 custom-add-only' />
                </p>

                <p className='w-750'>
                    <b>Problem:</b> Client's use of alcohol and/or illegal drugs has interfered with their quality of life and requires substance abuse treatment to reduce and/or eliminate problems related to the life style the client is living.
                </p>

                <p className='w-750'>
                    <b>Goal:</b> To develop a lifestyle were the use of alcohol and illegal drugs no longer impact their quality of life.
                </p>

                <table>
                    <tr>
                        <td className='w-125'>
                            <span className='eleHeader'>Objectives</span>
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>Activities Selected to Achieve Objectives</span>
                        </td>
                        <td className='w-120'>
                            <span className='eleHeader'>Frequency & Duration</span>
                        </td>
                        <td className='w-140'>
                            <span className='eleHeader'>Responsible Staff</span>
                        </td>
                        <td className='w-120'>
                            <span className='eleHeader'>Target Date</span>
                        </td>
                        <td className='w-120'>
                            <span className='eleHeader'>Date Completed</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>

                    <tr>
                        <td className='w-125'>1. Determine the complete impact that the client's use of alcohol and/or illegal
                            drugs has had on their quality of life, which will direct the course an individualized treatment program.</td>

                        <td className='w-125'>1. Complete psychosocial assessment.</td>
                        <td className='w-120'>1 time, 1.5 hours</td>
                        <td className='w-140'>
                            <input type='text' id='txtResponsibleStaff' name='txtResponsibleStaff' className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type='text' id='txtTargetDate' name='txtTargetDate' className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type='text' id='txtDateCompleted' name='txtDateCompleted' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-125'></td>
                        <td className='w-625'><hr /></td>
                    </tr>

                    <tr>
                        <td className='w-125'>&nbsp;</td>
                        <td className='w-125'>2. Complete medical history</td>
                        <td className='w-120'>1 time, .5 hour
                        </td>
                        <td className='w-140'>
                            <input type='text' id='txtResponsibleStaff4' name='txtResponsibleStaff4' className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type='text' id='txtTargetDate4' name='txtTargetDate4' className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type='text' id='txtDateCompleted4' name='txtDateCompleted4' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-125'></td>
                        <td className='w-625'><hr /></td>
                    </tr>

                    <tr>
                        <td className='w-125'>&nbsp;</td>
                        <td className='w-125'>3. Urinalysis Testing (ongoing)</td>
                        <td className='w-120'>Minimum 3 times during treatment episode, 7.5 hour
                        </td>
                        <td className='w-140'>
                            <input type='text' id='txtResponsibleStaff5' name='txtResponsibleStaff5' className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type='text' id='txtTargetDate5' name='txtTargetDate5' className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type='text' id='txtDateCompleted5' name='txtDateCompleted5' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-125'></td>
                        <td className='w-625'><hr /></td>
                    </tr>

                    <tr>
                        <td className='w-125'>&nbsp;</td>
                        <td className='w-125'>4. Participate in an ongoing assessment of progress during the treatment episode.</td>
                        <td className='w-120'>Minimum of 2 times, 1 hour
                        </td>
                        <td className='w-140'>
                            <input type='text' id='txtResponsibleStaff6' name='txtResponsibleStaff6' className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type='text' id='txtTargetDate6' name='txtTargetDate6' className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type='text' id='txtDateCompleted6' name='txtDateCompleted6' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-125'></td>
                        <td className='w-625'><hr /></td>
                    </tr>

                    <tr>
                        <td className='w-125'>&nbsp;</td>
                        <td className='w-125'>5. Complete a HIV/AIDS/TB/STD risk assessment screening.</td>
                        <td className='w-120'>1 time, .5 hour
                        </td>
                        <td className='w-140'>
                            <input type='text' id='txtResponsibleStaff7' name='txtResponsibleStaff7' className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type='text' id='txtTargetDate7' name='txtTargetDate7' className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type='text' id='txtDateCompleted7' name='txtDateCompleted7' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-125'>2. Participate in an individualized treatment program that will reduce and/or remove problems related to the client's use of alcohol and/or illegal drugs.</td>
                        <td className='w-125'>1. Participate in individual sessions to address issues on the individual treatment plan.</td>
                        <td className='w-120'>
                            <input type='text' id='txtParticipate8' name='txtParticipate8' className='add-only w-50 custom-add-only' /> Times per week, 1 hour each
                        </td>
                        <td className='w-140'>
                            <input type='text' id='txtResponsibleStaff8' name='txtResponsibleStaff8' className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type='text' id='txtTargetDate8' name='txtTargetDate8' className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type='text' id='txtDateCompleted8' name='txtDateCompleted8' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'></td>
                        <td className='w-625'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-125'>&nbsp;</td>
                        <td className='w-125'>2. Participate in group counseling sessions to address issues on the individual treatment plan.</td>
                        <td className='w-120'>
                            <input type='text' id='txtParticipate9' name='txtParticipate9' className='add-only w-50 custom-add-only' /> Times per week, 1.5 hours each
                        </td>
                        <td className='w-140'>
                            <input type='text' id='txtResponsibleStaff9' name='txtResponsibleStaff9' className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type='text' id='txtTargetDate9' name='txtTargetDate9' className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type='text' id='txtDateCompleted9' name='txtDateCompleted9' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'></td>
                        <td className='w-625'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-125'>&nbsp;</td>
                        <td className='w-125'>3. Participate in family counseling sessions (if applicable) to address issues related to developing a recovery support system.</td>
                        <td className='w-120'>
                            <input type='text' id='txtParticipate10' name='txtParticipate10' className='add-only w-50 custom-add-only' /> Times per week, 1.5 hours each
                        </td>
                        <td className='w-140'>
                            <input type='text' id='txtResponsibleStaff10' name='txtResponsibleStaff10' className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type='text' id='txtTargetDate10' name='txtTargetDate10' className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type='text' id='txtDateCompleted10' name='txtDateCompleted10' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'></td>
                        <td className='w-625'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-125'>&nbsp;</td>
                        <td className='w-125'>4. Participate in work related counseling (if applicable) to address issues related to developing a self-sustaining life style.</td>
                        <td className='w-120'>
                            <input type='text' id='txtParticipate11' name='txtParticipate11' className='add-only w-50 custom-add-only' /> Times per week, 1 hour
                        </td>
                        <td className='w-140'>
                            <input type='text' id='txtResponsibleStaff11' name='txtResponsibleStaff11' className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type='text' id='txtTargetDate11' name='txtTargetDate11' className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type='text' id='txtDateCompleted11' name='txtDateCompleted11' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'></td>
                        <td className='w-625'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-125'>&nbsp;</td>
                        <td className='w-125'>5. Participate in didactic presentations that are reflective of your needs to achieve success in developing a program of recovery.</td>
                        <td className='w-120'>
                            <input type='text' id='txtParticipate12' name='txtParticipate12' className='add-only w-50 custom-add-only' /> Times per week, 2 hours each
                        </td>
                        <td className='w-140'>
                            <input type='text' id='txtResponsibleStaff12' name='txtResponsibleStaff12' className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type='text' id='txtTargetDate12' name='txtTargetDate12' className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type='text' id='txtDateCompleted12' name='txtDateCompleted12' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'></td>
                        <td className='w-625'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-125'>&nbsp;</td>
                        <td className='w-125'>6. Participate in Relapse Prevention Program.</td>
                        <td className='w-120'>
                            <input type='text' id='txtParticipate13' name='txtParticipate13' className='add-only w-50 custom-add-only' /> Times, 2 hours
                        </td>
                        <td className='w-140'>
                            <input type='text' id='txtResponsibleStaff13' name='txtResponsibleStaff13' className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type='text' id='txtTargetDate13' name='txtTargetDate13' className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type='text' id='txtDateCompleted13' name='txtDateCompleted13' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'></td>
                        <td className='w-625'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-125'>&nbsp;</td>
                        <td className='w-125'>7. Participate in the development of your individual treatment plan.</td>
                        <td className='w-120'>1  Times, 1.5 hours
                        </td>
                        <td className='w-140'>
                            <input type='text' id='txtResponsibleStaff14' name='txtResponsibleStaff14' className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type='text' id='txtTargetDate14' name='txtTargetDate14' className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type='text' id='txtDateCompleted14' name='txtDateCompleted14' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'></td>
                        <td className='w-625'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-125'>&nbsp;</td>
                        <td className='w-125'>8. Participate in the development of your aftercare plan (if applicable).</td>
                        <td className='w-120'>1 Time, 1 hour
                        </td>
                        <td className='w-140'>
                            <input type='text' id='txtResponsibleStaff15' name='txtResponsibleStaff15' className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type='text' id='txtTargetDate15' name='txtTargetDate15' className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type='text' id='txtDateCompleted15' name='txtDateCompleted15' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'></td>
                        <td className='w-625'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-125'>&nbsp;</td>
                        <td className='w-125'>9. Participate in treatment plan reviews ever 30 days, while you are receiving substance abuse treatment services.</td>
                        <td className='w-120'>As required .5 hour each
                        </td>
                        <td className='w-140'>
                            <input type='text' id='txtResponsibleStaff16' name='txtResponsibleStaff16' className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type='text' id='txtTargetDate16' name='txtTargetDate16' className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type='text' id='txtDateCompleted16' name='txtDateCompleted16' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'></td>
                        <td className='w-625'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-125'>&nbsp;</td>
                        <td className='w-125'>10. Develop and participate in a personal program of recovery that will support your quality of life.</td>
                        <td className='w-120'>
                            <input type='text' id='txtParticipate17' name='txtParticipate17' className='add-only w-50 custom-add-only' /> Times weekly, 1 hour each
                        </td>
                        <td className='w-140'>
                            <input type='text' id='txtResponsibleStaff171' name='txtResponsibleStaff171' className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type='text' id='txtTargetDate171' name='txtTargetDate171' className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type='text' id='txtDateCompleted171' name='txtDateCompleted171' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-125'>3. Client Will provide the information needed to determine the level of care as established by the American Society of Addictions Medicines Placement Criteria.</td>
                        <td className='w-125'>1. Client will provide information that Will determine level of care.</td>
                        <td className='w-150'>At admission to program, .5 hour
                        </td>
                        <td className='w-140'>
                            <input type='text' id='txtResponsibleStaff17' name='txtResponsibleStaff17' className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type='text' id='txtTargetDate17' name='txtTargetDate17' className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type='text' id='txtDateCompleted17' name='txtDateCompleted17' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'></td>
                        <td className='w-625'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-125'>&nbsp;</td>
                        <td className='w-125'>2. Client's case will be subject to Continued Stay Criteria at time of treatment plan review.</td>
                        <td className='w-120'>Every 30 days, .5 hour
                        </td>
                        <td className='w-140'>
                            <input type='text' id='txtResponsibleStaff18' name='txtResponsibleStaff18' className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type='text' id='txtTargetDate18' name='txtTargetDate18' className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type='text' id='txtDateCompleted18' name='txtDateCompleted18' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'></td>
                        <td className='w-625'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-125'>&nbsp;</td>
                        <td className='w-125'>3. Client's case will meet Discharge/Transfer Criteria when appropriate.</td>
                        <td className='w-120'>As necessary
                        </td>
                        <td className='w-140'>
                            <input type='text' id='txtResponsibleStaff19' name='txtResponsibleStaff19' className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type='text' id='txtTargetDate19' name='txtTargetDate19' className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type='text' id='txtDateCompleted19' name='txtDateCompleted19' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-125'>Other :</td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='text' id='txtOther' name='txtOther' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtOther1' name='txtOther1' className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type='text' id='txtOther2' name='txtOther2' className='add-only' />
                        </td>
                        <td className='w-140'>
                            <input type='text' id='txtResponsibleStaff20' name='txtResponsibleStaff20' className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type='text' id='txtTargetDate20' name='txtTargetDate20' className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type='text' id='txtDateCompleted20' name='txtDateCompleted20' className='add-only' />
                        </td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Discharge Criteria:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Outcome Measures:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtDischargeCriteria' name='txtDischargeCriteria' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtOutcomeMeasures' name='txtOutcomeMeasures' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>At time of discharge,
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>1. Client will have demonstrated 30 consecutive days without the use of alcohol or illegal drugs.
                        </td>
                        <td className='w-375'>1. 30 day abstinence at time of discharge
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>2. Client will have sustained employment for 30 consecutive days prior to the completion of treatment.
                        </td>
                        <td className='w-375'>2. Gainfully employed at time of discharge
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>3. Client will yerbalize to counselor and peers a commitment to improve their quality of life.
                        </td>
                        <td className='w-375'>3. Commitment to improve quality of life
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>4. Client will have prepared an aftercare plan and made <br />
                            a commitment to follow through on that plan.</td>
                        <td className='w-375'>4. Aftercare Plan in place</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Issues to address on Individualized Treatment Plan:</span>
                    <textarea id='txtParentSpace2' name='txtParentSpace2' className='add-only'></textarea>
                </p>

            </div>
        </form>

    )
}

